import api from "../services/api";

/**
 * Servicio para manejar todas las operaciones de API relacionadas con facturas
 */
const invoiceService = {
  /**
   * Obtiene facturas con paginación y filtros opcionales
   */
  async fetchInvoices(page = 1, fromDate = null, toDate = null, tipo = null) {
    let url = `/invoices?page=${page}`;
    
    if (fromDate && toDate) {
      url += `&from=${fromDate}&to=${toDate}`;
    }

   // Filtro por tipo CF/CCF o estado anuladas
if (tipo && tipo !== "todas") {
  if (tipo === "anuladas") {
    url += `&estado=ANULADO`;
  } else {
    url += `&tipo=${tipo}`;
  }
}

    const response = await api.get(url);
    return response.data;
  },

  /**
   * Obtiene todas las facturas (sin paginación)
   */
  async fetchAllInvoices(fromDate = null, toDate = null, tipo = null) {
    let url = `/invoices?all=true`;
    
    if (fromDate && toDate) {
      url += `&from=${fromDate}&to=${toDate}`;
    }

// Filtro por tipo CF/CCF o estado anuladas
if (tipo && tipo !== "todas") {
  if (tipo === "anuladas") {
    url += `&estado=ANULADO`;
  } else {
    url += `&tipo=${tipo}`;
  }
}

    const response = await api.get(url);
    return response.data?.data ?? response.data ?? [];
  },

  /**
   * Anula una factura
   */
  async anularFactura(invoiceId, motivo) {
    const response = await api.post(`/invoices/${invoiceId}/anular`, {
      motivo
    });
    return response.data;
  },

  /**
   * Obtiene los detalles de invalidación de una factura
   */
  async getInvalidacion(invoiceId) {
    const response = await api.get(`/invoices/${invoiceId}/invalidacion`);
    return response.data;
  }
};

export default invoiceService;